import { AppContext } from "config/AppContext";
import { Component } from "react";
import { NotificationType } from "types/notification-type";
import { getTranslationText } from "utilities/translation-utilities";
import i18n from '../..//config/translations/i18n';
import * as lodash from 'lodash';

abstract class CoreComponent<TProps = any, TState = any> extends Component<TProps, TState> {
    static contextType = AppContext
    declare context: React.ContextType<typeof AppContext>;

    readonly lodash = lodash;

    constructor(props: TProps) {
        super(props);
    }

    componentDidMount() {
        if(super.componentDidMount) {
            super.componentDidMount();
        }
    }

    componentDidUpdate(prevProps: Readonly<TProps>, prevState: Readonly<TState>, snapshot?: any): void {
        if(super.componentDidUpdate) {
            super.componentDidUpdate(prevProps, prevState, snapshot);
        }
    }

    componentWillUnmount() {
        if(super.componentWillUnmount) {
            super.componentWillUnmount();
        }
    }

    notify = (type: NotificationType, message: string, description?: string) => {
        this.context.notify(type, message, description);
    }

    t = (key?: string) => {
        return getTranslationText(key, i18n.t);
    }
}

export default CoreComponent; 
